import firebase from "firebase/app";
import switchTheme from "@/styles/themes/themes";
export default {
    state: {
        info: {},
        theme: '',
    },
    getters: {
        info: s => s.info,
        theme: s => s.theme
    },
    mutations: {
        setInfo: (s, i) => s.info = i,
        setTheme: (s, t) => s.theme = t,
        clearInfo: (s) => s.info = {}
    },
    actions: {

        async setTheme({ commit }, { theme }) {
            switchTheme(theme)
            localStorage.setItem('theme', JSON.stringify({ theme }));
            commit('setTheme', theme);
        },

        async updateInfo({ dispatch, commit, getters }, toUpdate) {
            try {
                const uid = await dispatch('getUid')
                const updateData = { ...getters.info, ...toUpdate }
                const info = await firebase.database().ref(`/users/${uid}/info`).update(updateData) || {};
                commit('setInfo', info)
            } catch (e) {
                commit('setError', e)
                throw e
            }
        },
        async fetchUserInfo({ dispatch, commit }) {
            try {
                const uid = await dispatch('getUid')
                const info = (await firebase.database().ref(`/users/${uid}/info`).once('value')).val() || {};
                commit('setInfo', info);
            } catch (e) {
                commit('setError', e)
                throw e
            }
        }
    }
}
